/**
 * Builds the Firebase Storage object path used when uploading a merged
 * clinical-notes PDF for a single PA order.
 *
 * Pure function — no React. Lives outside the layout so the path scheme
 * can be unit-tested in isolation and reused by any submission flow.
 *
 * @param orgId   - Organization id used to namespace the upload bucket
 * @param orderId - PA order id; falsy values are interpolated as-is so
 *                  callers can decide whether to short-circuit upstream
 * @returns Storage object path of the form
 *          `onco_emr/{orgId}/{orderId}/clinical_attachment/clinical_notes_{timestamp}.pdf`
 */
import moment from "moment";

export const buildUploadFilePath = (
  orgId: string,
  orderId: string | undefined,
): string =>
  `onco_emr/${orgId}/${orderId}/clinical_attachment/clinical_notes_${moment().format(
    "YYYY-MM-DD-HH-mm-ss",
  )}.pdf`;
